/**
 * Visual style variants for the self-referral CTA
 */
export enum SelfReferralCTAStyle {
  /** The initial implementation of the self-referral CTA */
  INITIAL = 'initial',
  /** The implementation variant with a color and icon update */
  COLOR_AND_ICON_UPDATE = 'color-and-icon-update'
}

/**
 * Locations where the self-referral CTA can be displayed in the client portal
 */
export enum SelfReferralCtaLocationPage {
  /** The home page */
  HOME = 'home',
  /** The care team page */
  CARE_TEAM = 'care-team'
}
